import type { ReactNode, SVGProps } from "react";

/*
 * Значки интерфейса в стиле Д2, как глифы иконок разделов
 * (chmk-erp, ops/app_icons.py): сетка 24, линия 2, концы и углы прямые или
 * 45°. Свои, а не Font Awesome: его значки под CC BY 4.0, вне списка
 * лицензий.
 */

export type IconProps = SVGProps<SVGSVGElement>;

function icon(d: string, extra?: (p: IconProps) => ReactNode) {
  return function Icon(props: IconProps) {
    return (
      <svg
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="square"
        strokeLinejoin="miter"
        aria-hidden="true"
        focusable="false"
        {...props}
      >
        <path d={d} />
        {extra?.(props)}
      </svg>
    );
  };
}

export const IconMenu = icon("M3 6h18 M3 12h18 M3 18h18");
export const IconClose = icon("M5 5l14 14 M19 5L5 19");
export const IconSearch = icon("M4 4h10v10H4z M14 14l6 6");
export const IconCamera = icon("M3 7h4l2-3h6l2 3h4v13H3z M9 10h6v6H9z");
export const IconScan = icon("M3 8V3h5 M16 3h5v5 M21 16v5h-5 M8 21H3v-5 M7 8v8 M10 8v8 M13 8v8 M17 8v8");
export const IconSun = icon("M8 8h8v8H8z M12 2v3 M12 19v3 M2 12h3 M19 12h3 M4.5 4.5l2 2 M17.5 17.5l2 2 M19.5 4.5l-2 2 M6.5 17.5l-2 2");
export const IconMoon = icon("M14 3a9 9 0 1 0 7 13A7 7 0 0 1 14 3z");
export const IconLogout = icon("M10 3H3v18h7 M16 7l5 5-5 5 M21 12H9");
export const IconUser = icon("M9 3h6v6H9z M4 21v-5l3-3h10l3 3v5");
export const IconChevronRight = icon("M9 5l7 7-7 7");
export const IconCommand = icon("M4 4h16v16H4z M8 10l2 2-2 2 M12 15h4");
export const IconHome = icon("M3 3h8v8H3z M13 3h8v8h-8z M3 13h8v8H3z M13 13h8v8h-8z");

/* Глифы плиток стола. */
export const IconShelf = icon("M3 3h18v18H3z M3 9h18 M3 15h18 M8 5v2 M14 11v2 M10 17v2");
export const IconQr = icon("M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h3v3h-3z M20 14v1 M14 20h1 M18 18h3v3h-3z");
export const IconTruck = icon("M2 5h12v11H2z M14 9h4l4 4v3h-8 M6 16v3h2v-3 M16 16v3h2v-3");
export const IconKit = icon("M3 3h8v8H3z M13 3h8v8h-8z M8 13h8v8H8z");
export const IconSend = icon("M3 11l18-8-8 18-2-8z M11 13l10-10");
export const IconAlert = icon("M12 3l10 18H2z M12 10v5 M12 18v1");
export const IconPencil = icon("M16 3l5 5L9 20H4v-5z M13 6l5 5");
export const IconClock = icon("M3 3h18v18H3z M12 7v6h4");
export const IconWrench = icon("M15 3l-3 3v4l-9 9 2 2 9-9h4l3-3-2-2-2 2h-2V7l2-2z");
export const IconFlask = icon("M9 3h6 M10 3v6l-6 12h16L14 9V3 M7 15h10");
export const IconTasks = icon("M3 3h18v18H3z M7 12l3 3 7-7");
export const IconRefresh = icon("M20 12a8 8 0 1 1-2.3-5.7 M20 4v5h-5");
export const IconArrowLeft = icon("M10 5l-7 7 7 7 M3 12h18");
export const IconCheck = icon("M4 12l5 5L20 6");
export const IconPlus = icon("M12 4v16 M4 12h16");
export const IconTrash = icon("M4 6h16 M9 6V3h6v3 M6 6l1 15h10l1-15");
